import React from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// ui-kit
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'

// components
import PermanentSearchDialog from '../../../permanent-serch'
import Skills from '../../Skills'

const Component = ({ aviso }) => {
  const isMobile = useWindowSize()

  return (
    <Row>
      <Col>
        {aviso.tipoAviso === 'infinit' && <PermanentSearchDialog />}

        {!isMobile && (
          <>
            {aviso.requisitos && aviso.requisitos.conocimientos && (
              <Skills conocimientos={aviso.requisitos.conocimientos} />
            )}
          </>
        )}
      </Col>
    </Row>
  )
}

export default Component
